<template>
  <div>
    <div class="container page-section verity-mt">
      <template v-if="fromPage">
        <div class="text-center">
          <div class="col-md-12 icon-password">
            <img
              src="/img/icons/password.svg"
              alt="Password Login SVG"
            >
          </div>
        </div>
        <div class="col-md-12">
          <div class="content">
            <div class="row text-center">
              <div class="col-md-12 mv15">
                <template v-if="fromPage === 'reset-password'">
                  <h3>{{ $t('label.changeYourPassword') }}</h3>
                </template>
                <template v-if="fromPage === 'forget-password'">
                  <h3>{{ $t('label.resetPassword') }}</h3>
                </template>
              </div>
              <div class="col-md-12 mv15">
                <b-alert
                  show
                  variant="primary"
                  dismissible
                >
                  {{ $t('string.messageResetPassword') }}
                </b-alert>
              </div>
              <template v-if="this.errorMessage">
                <div class="col-md-12 mv15">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                  >
                    {{ this.errorMessage }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </template>
              <template v-if="fromPage === 'reset-password'">
                <div class="col-md-12 mv15">
                  <div class="form-group">
                    <input
                      type="password"
                      v-model="old_password"
                      class="form-control form-control-lg "
                      :class="messageValidate && messageValidate.hasOwnProperty('old_password') ? 'input-error': ''"
                      :placeholder="$t('label.placeholder.currentPassword')"
                    >
                    <span
                      class="label-error"
                      v-if="messageValidate && messageValidate.hasOwnProperty('old_password')"
                    >
                      {{ messageValidate.old_password[0] }}
                    </span>
                  </div>
                </div>
              </template>
              <div class="col-md-12 mv15">
                <div class="form-group">
                  <input
                    type="password"
                    v-model="password"
                    class="form-control form-control-lg "
                    :class="messageValidate && messageValidate.hasOwnProperty('password') ? 'input-error': ''"
                    :placeholder="$t('fields.label.newPassword')"
                  >
                  <span
                    class="label-error"
                    v-if="messageValidate && messageValidate.hasOwnProperty('password')"
                  >
                    {{ messageValidate.password[0] }}
                  </span>
                </div>
              </div>
              <div class="col-md-12 mv15">
                <div class="form-group">
                  <input
                    type="password"
                    v-model="password_confirmation"
                    class="form-control form-control-lg "
                    :class="messageValidate && messageValidate.hasOwnProperty('password_confirmation') ? 'input-error': ''"
                    :placeholder="$t('fields.label.passwordConfirmation')"
                  >
                  <span
                    class="label-error"
                    v-if="messageValidate && messageValidate.hasOwnProperty('password_confirmation')"
                  >
                    {{ messageValidate.password_confirmation[0] }}
                  </span>
                </div>
              </div>
            </div>
            <div class="row text-center">
              <template v-if="fromPage === 'reset-password'">
                <div class="col-md-12 mv15">
                  <button
                    class="btn btn-cash-hero btn-lg btn-block"
                    @click="resetPassword"
                  >
                    {{ $t('global.btn.submit') }}
                  </button>
                </div>
                <div class="col-md-12 mv15">
                  <button
                    class="btn btn-link btn-block"
                    @click="$router.push({name: 'profile' , params: {activeTabs: 'profile'}})"
                  >
                    {{ $t('label.backToProfileDetail') }}
                  </button>
                </div>
              </template>
              <template v-else-if="fromPage === 'forget-password'">
                <div class="col-md-12 mv15">
                  <button
                    class="btn btn-cash-hero btn-lg btn-block"
                    @click="forgetPassword"
                  >
                    {{ $t('global.btn.resetPassword') }}
                  </button>
                </div>
                <div class="col-md-12 mv15">
                  <button
                    class="btn btn-link btn-block"
                    @click="$router.push({name: 'login'})"
                  >
                    {{ $t('label.backToLoginPage') }}
                  </button>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <error-load-page />
      </template>
    </div>
  </div>
</template>

<script>
import ErrorLoadPage from '../../../components/ErrorLoadPage'
export default {
  name: 'ResetPassword',
  metaInfo: {
    title: 'Reset Password',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'User reset password' }
    ]
  },
  components: { ErrorLoadPage },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    fromPage: {
      type: String
    }
  },
  data () {
    return {
      messageValidate: [],
      old_password: '',
      password: '',
      password_confirmation: '',
      errorMessage: ''
    }
  },
  watch: {
    '$i18n.locale': {
      handler: function () {
        this.messageValidate = []
      }
    }
  },
  methods: {
    resetPassword () {
      this.$isLoading(true)
      this.errorMessage = ''
      const data = {
        old_password: this.old_password,
        password: this.password,
        password_confirmation: this.password_confirmation
      }
      this.$axios.post(this.$base_api + '/api/v1/frontend/auth/reset-password', data)
        .then((response) => {
          const result = response.data
          if (result.code === 1) {
            this.$store.dispatch('boardInformation/toggleShowValue', false)
            this.$store.dispatch('resetStateBorrower')
            this.$store.dispatch('checkUserHasPendingLoan', false)
            this.$store.dispatch('checkUserLogin', false)
            this.$axios.defaults.headers.common.Authorization = null
            localStorage.clear()
            sessionStorage.clear()
            this.$router.push({ name: 'info-page' })
          } else {
            if (result.hasOwnProperty('message')) {
              this.messageValidate = result.message
            } else {
              this.errorMessage = response.data['message_' + this.$i18n.locale]
            }
          }
        }).catch((error) => {
          this.responseError(error.response)
        }).finally(() => {
          this.$isLoading(false)
        })
    },
    forgetPassword () {
      this.$isLoading(true)
      const data = {
        borrow_uuid: sessionStorage.getItem('uid'),
        password: this.password,
        password_confirmation: this.password_confirmation
      }
      this.$axios.post(this.$base_api + '/api/v1/frontend/auth/forgot-password', data)
        .then((response) => {
          const result = response.data
          if (result.code === 1) {
            this.$store.dispatch('boardInformation/toggleShowValue', false)
            this.$store.dispatch('resetStateBorrower')
            this.$store.dispatch('checkUserHasPendingLoan', false)
            this.$store.dispatch('checkUserLogin', false)
            this.$axios.defaults.headers.common.Authorization = null
            localStorage.clear()
            sessionStorage.clear()
            this.$router.push({ name: 'info-page' })
          } else {
            if (result.hasOwnProperty('message')) {
              this.messageValidate = result.message
            } else {
              const message = response.data['message_' + this.$i18n.locale]
              this.$swal.fire({
                type: 'error',
                text: message
              })
            }
          }
        }).catch((error) => {
          this.responseError(error.response)
        }).finally(() => {
          this.$isLoading(false)
        })
    }
  }
}
</script>

<style scoped>
  .label-error {
    float: left;
  }
  .verity-mt {
    margin-top: 0;
  }

  .icon-password img{
    width: 15%;
  }

  .content {
    margin: 0 auto;
    width: 50%;
  }

  .mv15 {
    margin: 6px 0;
  }

  @media (max-width: 992px) {
    .icon-password img{
      width: 22%;
    }

    .content {
      width: 65%;
    }
  }

  @media (max-width: 768px) {
    .content {
      width: 90%;
    }

    .icon-password img{
      width: 25%;
    }
  }

  @media (max-width: 576px) {
    .verity-mt {
      margin-top: 1rem;
    }

    .icon-password img{
      width: 35%;
    }

    .content {
      width: 100%;
    }
  }
</style>
